import React from 'react';
import TOOLS from 'constants/tools';
import ToolButton from 'components/buttons/ToolButton';
import PawIcon from 'components/PawIcon'; // adjust path if needed

function RecommendedLegend({ variant = 'inline' }) {
  const base =
    'flex items-center gap-2 text-[11px] text-gray-600 bg-white/90 rounded-md px-2 py-1 shadow-sm';

  if (variant === 'overlay') {
    return (
      <div className={`${base} absolute -top-3 right-1 left-auto z-10`}>
        {/* <PawIcon size={18} className="text-black" /> */}
        <div className="bg-black flex items-center justify-center rounded-full bg-black/85 p-0.5">
          <PawIcon className="h-3 w-3 text-white" />
        </div>
        <span>= Recommended for pet photos</span>
      </div>
    );
  }

  return (
    <div className="mt-2 hidden lg:flex items-start gap-2 text-xs text-gray-600">
      <div className="bg-black flex items-center justify-center rounded-full bg-black/85 p-0.5">
        <PawIcon className="h-3 w-3 text-white" />
      </div>
      <span>= Recommended for pet photos</span>
    </div>
  );
}

export default function Toolbar({
  activeTool,
  setActiveTool,
  mainTooltipSequence,
}) {
  // Works whether activeTool is a string or an object
  const isFiltersSelected =
    activeTool === 'filters' ||
    activeTool === 'Filters' ||
    activeTool?.key === 'filters' ||
    activeTool?.id === 'filters' ||
    activeTool?.title === 'Filters';

  return (
    <div className="relative w-full">
      <div className="font-bold hidden md:block">Tools</div>

      {/* Keep the overlay OUTSIDE the scrolling row so it's pinned to the visible right edge */}
      {isFiltersSelected && (
        <div className="md:hidden">
          <RecommendedLegend variant="overlay" />
        </div>
      )}

      {/* Make ONLY the buttons row scrollable on mobile */}
      <div className="flex md:block snap-x snap-always scroll-smooth ">
        {TOOLS.map((tool, index) => (
          <ToolButton
            activeTool={activeTool}
            setActiveTool={setActiveTool}
            tool={tool}
            key={`${tool.title}${index}`}
            mainTooltipSequence={mainTooltipSequence}
          />
        ))}
        <span className="lg:hidden">&nbsp;</span>
      </div>

      {/* Desktop: normal below tools */}
      {isFiltersSelected && (
        <div className="hidden lg:block">
          <RecommendedLegend variant="inline" />
        </div>
      )}
    </div>
  );
}
